import  i18n  from './i18n'
const t = i18n.global.t
export function getUrlQuery(name: string) {
    // 构造一个含有目标参数的正则表达式对象
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
    // 匹配目标参数
    const r = window.location.search.substr(1).match(reg)
    // 返回参数
    if (r != null) {
        return decodeURIComponent(r[2])
    }
    return null
}
interface CodeType {
    [key: string]: string
}

export const codeConfig: CodeType = {
    '40016': t('message.zhanghaoshangweizhuce'),
    '40015': t('message.zhanghaoyijingcunzai'),
    '40009': t('message.shoujihaoweizhuce'),
    '40002': t('message.zhanghaogeshicuowu'),
    '40003': t('message.shoujihaoyizhuce'),
    '40004': t('message.yanzhengmadashangxian'),
    '40014': t('message.yanzhengmacuowu'),
    '40013': t('message.yangzhengmashixiao'),
    '40012': t('message.yanzhengmabucunzai'),
    '40017': t('message.zhanghaomimacuowu'),
    '40022': t('message.xinjiumimayizhi'),
    '40023': t('message.tuxingyanzhengmacuowu'),
    '40036': t('message.dengluchushihua')
}

export function mobileDesensitization (phone: string) {
    const pat=/(\d{3})\d*(\d{4})/
    return phone.replace(pat,'$1****$2')
}

// 邮箱脱敏函数
export function emailDesensitization(email: string) {
    if (!email) return email
    const parts = email.split('@')
    if (parts.length !== 2) return email // 不是有效的邮箱格式
    
    const [localPart, domainPart] = parts
    if (localPart.length <= 1) {
        return `${localPart}@${domainPart}`
    } else if (localPart.length <= 3) {
        return `${localPart.charAt(0)}***@${domainPart}`
    } else {
        const showChars = Math.min(2, localPart.length - 1) // 显示前2位，但不超过总长度-1
        const hiddenPart = '*'.repeat(Math.max(3, localPart.length - showChars))
        return `${localPart.substring(0, showChars)}${hiddenPart}@${domainPart}`
    }
}
